(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nordkaj-bundle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nordkaj-bundle')) {
    customElements.define(
      'nordkaj-bundle',
      class extends HTMLElement {
        connectedCallback() {
          // The product section is re-rendered on every variant change; keep the visitor's choice.
          const key = `nk-bundle:${this.dataset.productId}`;
          const saved = sessionStorage.getItem(key);
          const radios = [...this.querySelectorAll('input[type="radio"]')];
          const pick = radios.find((r) => r.value === saved) || radios.find((r) => r.checked);
          if (pick) pick.checked = true;
          this.addEventListener('change', (e) => {
            sessionStorage.setItem(key, e.target.value);
            this.apply(e.target.value);
          });
          if (pick) this.apply(pick.value);
        }

        apply(qty) {
          const section = this.closest('.shopify-section') || document;
          const input = section.querySelector('input[name="quantity"]');
          if (!input) return;
          input.value = qty;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
